import UserInfo from 'src/lib/userinfo.min'
// var detectAutoplay = require('detect-audio-autoplay')
// var detectBuffer = require('detect-audio-autoplay/buffer')

export const getCountry = function({commit}) {
  return new Promise((resolve)=> {
    UserInfo.getInfo((data)=> {
      commit('setCountry', data.country.code)
      resolve()
    })
  })
}

// export const checkAudio = function({commit}) {
//   detectAutoplay(function (supported) {
//     commit('audioPlayable', supported)
//   })
//   detectBuffer(function (supported) {
//     commit('audioBufferable', supported)
//   })
// }


// WEBPACK FOOTER //
// ./src/store/browser/actions.js